import { useEffect } from "react";
import { Slider, TextField, withStyles } from "@material-ui/core";
import { useField, useFormikContext } from "formik";

const FormLabel = {
  fontSize: "14px",
  fontFamily: `'Roboto', sans-serif`,
  marginLeft: "5px",
  marginBottom: "6px",
  fontWeight: 400,
  color: "#111111",
};

export default function FormSliderInput({
  required = false,
  options,
  name,
  label,
  fullWidth,
  maxValue,
  minValue,
  commonProps = {},
  ...rest
}) {
  const [field, meta, { setValue, setTouched }] = useField(name);
  const { value, onBlur } = field;
  const formikContext = useFormikContext();

  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  function handleChange(e, newValue) {
    setTouched(true);
    setValue(newValue);
  }
  function handleTextFieldChange(e) {
    setTouched(true);
    setValue(e.target.value);
  }
  return (
    <>
      <div className="d-flex flex-column" style={{ paddingBottom: 20 }}>
        <div className="nps-form-label">
          {label}
          {required && "*"}
        </div>
        <div className="d-flex flex-row">
          <CustomSlider
            max={maxValue}
            min={minValue || 0}
            disabled={disabled}
            value={value || 0}
            step={1}
            valueLabelDisplay="auto"
            onChange={handleChange}
            onChangeCommitted={handleChange}
          />
          <SmallTextField
            value={value}
            variant="outlined"
            size="small"
            disabled={disabled}
            onChange={handleTextFieldChange}
            onBlur={onBlur}
            {...rest}
          />
        </div>
        <div className="nps-error-message">{errorMessage}</div>
      </div>
    </>
  );
}

const CustomSlider = withStyles({
  root: {
    width: 200,
    height: 8,
    marginLeft: "12px",
    marginTop: "10px",
    backgroundColor: "white",
    borderRadius: "5px",
    color: "#033f7c",
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const SmallTextField = withStyles({
  root: {
    fontSize: "14px",
    fontFamily: "OpenSans-Regular",
    marginLeft: "12px",
    marginTop: 8,
    fontWeight: 400,
    color: "#000",
    width: 80,
  },
})(TextField);
